(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nxt2none-bundle-choices')) {
  customElements.define('nxt2none-bundle-choices', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.dataset.ready) return;
      const parent = this.closest('variant-selects');
      const native = parent.querySelector('select[name^="options["]');
      if (!native) return;
      const parse = value => {
        const match = value.match(/^(.+) Scrub \+ (.+) Balm$/);
        return match ? [match[1], match[2]] : null;
      };
      const pairs = Array.from(native.options).map(option => ({value: option.value, parts: parse(option.value)}));
      if (!pairs.length || pairs.some(pair => !pair.parts)) return;
      const selected = parse(native.value);
      if (!selected) return;
      const selects = [this.querySelector('[data-bundle-scrub]'), this.querySelector('[data-bundle-balm]')];
      selects.forEach((select, index) => {
        for (const value of new Set(pairs.map(pair => pair.parts[index]))) {
          select.add(new Option(value, value));
        }
        select.value = selected[index];
      });
      this.addEventListener('change', event => {
        event.stopPropagation();
        const pair = pairs.find(pair => pair.parts.every((value, index) => value === selects[index].value));
        if (!pair) return;
        native.value = pair.value;
        native.dispatchEvent(new Event('change', { bubbles: true }));
      });
      native.closest('.product-form__input').style.display = 'none';
      this.hidden = false;
      this.dataset.ready = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
